import { Navigate, useParams } from 'react-router-dom'

/**
 * Redirects /policies/:id to /cases/:id (policies consolidated into cases).
 */
export function PolicyIdRedirect() {
  const { id } = useParams()
  return <Navigate to={`/cases/${id}`} replace />
}

export default PolicyIdRedirect
